import FileUpload from '@/components/Widgets/Upload/FileUpload';
import { UsersViewModel } from '@/viewModels/users';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    FileUpload
  }
})
export default class UserList extends Vue {
  public viewModel = new UsersViewModel();
  public role: string;
  public email: string;
  public newEmail: string;
  public confirmEmail: string;
  public username: string;
  public password: string;
  public confirmPassword: string;
  public newRole: string;
  public showUpload = false;
  public valid: boolean = true;

  public get emailRules() {
    return [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ];
  }
  public get emailMatchRule() {
    return [v => v === this.newEmail || 'Emails do not match'];
  }
  public get nameRules() {
    return [v => !!v || 'Username is required'];
  }
  public get passworRules() {
    return [v => !!v || 'Password is required'];
  }

  public get passwordMatchRule() {
    return [v => v === this.password || 'Passwords do not match'];
  }
  public get roleRequiredRule() {
    return [v => !!v || 'Role is required'];
  }
  public get roles() {
    return this.$dataService.roles();
  }
  public get busy() {
    return this.$store.getters.isBusy;
  }
  public get isDialogOpen() {
    return this.$store.getters.dialogOpen;
  }
  public get form(): any {
    return this.$refs.form;
  }

  public get users() {
    return this.$store.getters.users;
  }
  public confirmDelete(user: any) {
    this.confirm.open().then(decision => {
      if (decision) {
        this.$userService.removeUser(user.id).then(x => this.search());
      }
    });
  }
  public get confirm(): any {
    return this.$refs.$confirm;
  }

  public search() {
    this.$userService.searchUsersByRole(this.role);
  }
  public addUser() {
    this.$actions.setDialogState(true);
  }
  public saveUser() {
    if (this.form.validate()) {
      this.valid = true;
      this.$userService
        .addUser(this.newEmail, this.username, this.password, [this.newRole])
        .then(x => {
          this.$actions.setDialogState(false);
          this.role = this.newRole;
          this.search();
        });
    } else {
      this.valid = false;
    }
  }
  mounted() {
    this.role = 'admin';

    this.search();
  }
  public closeDialog() {
    this.$actions.setDialogState(false);
  }

  public reset() {
    this.form.reset();
  }
  public resetValidation() {
    this.form.resetValidation();
  }
}
